export const OFFER_TYPE_CASINO = 'casino';

export const DYNAMIC_PRICE = 'dynamicPrice';

export const testPerks = [
  {
    __typename: 'PricePerk',
    name: 'onboardCredit',
    description: ['$ 200 instant savings', 'Up to 200 to spend at sea'],
    price: {
      currency: {
        code: 'USD',
        __typename: 'Currency',
      },
      value: 2,
      __typename: 'Price',
    },
    qualifier: null,
  },
  {
    __typename: 'PricePerk',
    name: 'instantSavings',
    description: ['50 % off second guest', 'Kids sail free'],
    price: {
      currency: {
        code: 'USD',
        __typename: 'Currency',
      },
      value: 1,
      __typename: 'Price',
    },
    qualifier: null,
  },
  {
    __typename: 'PercentOffPerk',
    name: 'percentOff',
    target: 'all',
    percent: 1,
    qualifier: null,
  },
];
export const testTargetedOffer = {
  campaignId: '6398242d18ee5500196512d5',
  id: '6398242d18ee5500196512d4',
  code: 'casbdoi-14-12-2022',
  couponCode: 'CASBDOIFNY9G86',
  type: 'casino',
  title: 'Casino Royale Offer Title 4',
  startDate: '2022-12-14T05:00:00.000Z',
  endDate: '2023-03-08T01:00:00.000Z',
  description: 'CASINO4 Description',
  fareCodes: ['K5643177'],
  criteria: [
    {
      ships: ['AD'],
      startDate: [
        {
          start: '2023-02-01T07:02:00.000Z',
          end: '2023-02-27T07:02:00.000Z',
          __typename: 'CriteriaDateRange',
        },
      ],
      __typename: 'Criteria',
    },
  ],
  termsAndConditions: {
    link: '/terms-and-conditions/promotions/loyalty01-16-09-2022',
    experienceFragment:
      '/content/experience-fragments/promotions/2022/september/september_monthly/terms_conditions/en/usa-usd',
    __typename: 'TermsAndConditions',
  },
  perks: [
    {
      __typename: 'BooleanPerk',
      name: 'complementaryStateroom',
      description: ['Complimentary Stateroom including'],
      qualifier:
        'Interior, Ocean View, Balcony or Junior Suite Stateroom for two',
    },
  ],
  __typename: 'Promotion',
};
